import { IndirectPaginatedAPIData, PaginatedAPIData } from 'utils/apidata';
import { PullRequest } from 'stores/pullRequests/models';
import {
  emptyIndirectPaginatedAPIData,
  emptyPaginatedAPIData,
  listEntries,
  listMapEntryData,
} from 'Common/utilities/pagination';
import { getPullRequestsKey, PullRequestsRequest } from './generators';
import { createSelector } from 'reselect';
import { selectors as pullRequestsSelectors } from '../../pullRequests/selectors';
import { getKeyByPullRequest } from '../../pullRequests/generators';
import { IndirectAPIData } from 'utils/apidata';
import { getStore } from 'stores/common/selectors';

export function indirect(state: any): IndirectPaginatedAPIData<PullRequest> {
  const store = getStore(state);
  return (
    store.organizations.pullRequests?.pages ?? emptyIndirectPaginatedAPIData
  );
}

export function pages(
  state: any,
  request: PullRequestsRequest
): PaginatedAPIData<PullRequest> {
  const key = getPullRequestsKey(request);
  return indirect(state)[key] ?? emptyPaginatedAPIData;
}

export function activePages(
  state: any,
  organizationUUID: string
): PaginatedAPIData<PullRequest> {
  return pages(state, { organizationUUID, status: 'active' });
}

export const active = createSelector(
  [activePages, pullRequestsSelectors.entries],
  (
    pages: PaginatedAPIData<PullRequest>,
    entries: IndirectAPIData<PullRequest>
  ) => listMapEntryData(entries, getKeyByPullRequest, listEntries(pages))
);

export function inactivePages(
  state: any,
  organizationUUID: string
): PaginatedAPIData<PullRequest> {
  return pages(state, { organizationUUID, status: 'inactive' });
}

export const inactive = createSelector(
  [inactivePages, pullRequestsSelectors.entries],
  (
    pages: PaginatedAPIData<PullRequest>,
    entries: IndirectAPIData<PullRequest>
  ) => listMapEntryData(entries, getKeyByPullRequest, listEntries(pages))
);

export const selectors = {
  indirect,
  pages,
  activePages,
  active,
  inactivePages,
  inactive,
};
